import { type FC } from "react";

import { Grid } from "@mantine/core";

import { HomeTrendingOnSpotlightTable } from "./HomeTrendingOnSpotlightTable";
import { HomeTrendingTagsTable } from "./HomeTrendingTagsTable";

const GRID_TOTAL = 12;
const SPOTLIGHT_COLUMNS = 4;
const TAGS_COLUMNS = GRID_TOTAL - SPOTLIGHT_COLUMNS;

export const HomeTrendingSection: FC = () => {
    return (
        <Grid gutter="lg">
            <Grid.Col span={{ base: 12, sm: SPOTLIGHT_COLUMNS }}>
                <HomeTrendingOnSpotlightTable />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: TAGS_COLUMNS }}>
                <HomeTrendingTagsTable />
            </Grid.Col>
        </Grid>
    );
};
